import { BATCH_TOOLS } from 'pages/Batch/configs';
import CropItem from 'pages/Batch/components/CropItem';
import GridItemImageBox from 'components/common/GridItemImageBox';
import ResizeGridItem from 'pages/Batch/components/ResizeGridItem';
import RemoveBgGridItem from 'pages/Batch/components/RemoveBgGridItem';
import GridItemEnhanceImage from 'components/common/GridItemEnhanceImage';
import WatermarkGridItem from 'pages/Batch/components/WatermarkGridItem';
import RemoveBgResizeGridItem from 'pages/Batch/components/RemoveBgResizeGridItem';

interface IGridItemProps {
  imgSrc: string;
  boxWidth?: number;
  boxHeight: number;
  itemKey?: string;
}

interface IGridItemComponent {
  [key: string]: {component: (props: IGridItemProps) => JSX.Element; processOnApply?: boolean; isPremium?: boolean};
}

const GridItemComponent = {
  [BATCH_TOOLS.resize]: {
    component: ResizeGridItem,
    processOnApply: true,
  },
  [BATCH_TOOLS.enhance]: {
    component: GridItemEnhanceImage,
    isPremium: true,
  },
  [BATCH_TOOLS.removeBG]: {
    component: RemoveBgGridItem,
    isPremium: true,
  },
  [BATCH_TOOLS.removeBG_resize]: {
    component: RemoveBgResizeGridItem,
    isPremium: true,
  },
  [BATCH_TOOLS.crop]: {
    component: CropItem,
  },
  [BATCH_TOOLS.upload]: {
    component: GridItemImageBox,
  },
  [BATCH_TOOLS.watermark]: {
    component: WatermarkGridItem,
    isPremium: true,
  },
  defaultItem: {
    component: GridItemImageBox,
  },
} as IGridItemComponent;

export default GridItemComponent;
